export default "__VITE_ASSET__CncWjucd__"